import { AccessDeniedComponent } from './shared/access-denied/access-denied.component';
import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { TemplateWrapperComponent } from './layout/template-wrapper/template-wrapper.component';
import { NotFoundComponent } from './shared/not-found/not-found.component';
import { AuthGuard } from './shared/route-guards/auth.guard';

const routes: Routes = [
  {
    path: '',
    redirectTo: '/login',
    pathMatch: 'full'
  },
  {
    path: '',
    loadChildren: './authentication/authentication.module#AuthenticationModule',

  },
  {
    path: '',
    component: TemplateWrapperComponent,
    canActivate: [AuthGuard],
    children: [
      {
        path: '',
        loadChildren: './pages/pages.module#PagesModule',
      },
      {
        path: 'experiences',
        loadChildren: './experiences/experiences.module#ExperiencesModule'
      },
      {
        path: 'packages',
        loadChildren: './packages/packages.module#PackagesModule'
      },
      {
        path: 'travelers',
        loadChildren: './travelers/travelers.module#TravelersModule'
      },
      {
        path: 'settings',
        loadChildren: './settings/settings.module#SettingsModule'
      },
      {
        path: 'filters',
        loadChildren: './filters/filters.module#FiltersModule'
      },
      {
        path: 'bookings',
        loadChildren: './bookings/bookings.module#BookingsModule'
      },
      {
        path: 'locals',
        loadChildren: './locals/locals.module#LocalsModule'
      },
      {
        path: 'accommodations',
        loadChildren: './accommodation/accommodation.module#AccommodationModule'
      },
      {
        path: 'inquiries',
        loadChildren: './inquiries/inquiry.module#InquiryModule'
      },
      {
        path: 'payments',
        loadChildren: './payment/payment.module#PaymentModule'
      },
      {
        path: 'destinations',
        loadChildren: './destinations/destinations.module#DestinationsModule'
      }
    ]
  },
  {
    path: 'access-denied',
    component: AccessDeniedComponent
  },
  { path: '**', component: NotFoundComponent }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
